export const envConfigs = {
  isLoginFormEnabled: import.meta.env.VITE_SHOW_LOGIN_FORM === 'true',
  showBuildVersions: import.meta.env.VITE_SHOW_BUILD_VERSIONS === 'true',
};
